import { WarningWingsGreyscaleIllustration } from '@carboncopyco/illustrations';
import type { IVariable, PlaybookAsset } from '@carboncopyco/types';
import { TextBase } from '@carboncopyco/ui';
import { usePlayAnalytics } from '@carboncopyco/utils';
import { useEffect } from 'react';
import { VariableInput, VariablesTable } from '../../../DemoVariables';
import { useGiveADemo } from '../GiveADemoContext';

type VariablesTabProps = {
  variables: IVariable[];
  entityId: string;
  entityType: PlaybookAsset['assetType'];
};
export const VariablesTab = ({ variables, entityId }: VariablesTabProps) => {
  const { playSource } = useGiveADemo();
  const { trackPlayOpenAssetVariables } = usePlayAnalytics(
    'give_a_demo_modal_customize_modal'
  );

  useEffect(() => {
    trackPlayOpenAssetVariables({
      demoId: entityId,
      playSource,
    });
  }, [trackPlayOpenAssetVariables, entityId, playSource]);

  return (
    <div className="px-8 py-7 w-full flex flex-col h-full">
      {variables.length ? (
        <div className="max-h-48 ">
          <VariablesTable
            variables={variables}
            renderVariableInput={(variable, index) => (
              <VariableInput
                variable={variable}
                name={`variables.${entityId}.${index}.value`}
              />
            )}
            showHeaders={false}
          />
        </div>
      ) : (
        <div className="flex flex-col items-center justify-center grow">
          <WarningWingsGreyscaleIllustration
            width={45}
            height={45}
          />
          <div className="mt-2.5">
            <TextBase
              label={`This demo doesn't include any variables`}
              color="text-ds-natural-600"
            />
          </div>
        </div>
      )}
    </div>
  );
};
